/**
 * Given an array of columns (options.columns) and a BatchGeoTable row set
 * (options.rows) it will return a string based version of a table. It keeps
 * sorts by the options.sortAgainst option which takes BGT row data and makes
 * sure the string version of the table matches the same sorting. It exports
 * in a format that can be pasted into Excel or similar.
 */
window.TableExporter = (function () {
  /**
   * @param {array} opts.columns        An array of column names
   * @param {object} opts.rows          BatchGeoTable row collection
   * @param {object} opts.sortAgainst   A sorted collection of BatchGeoTable
   *                                    row data to match the selected rows with
   *
   * @returns {string} A string representation of the table
   */
  return function BatchGeoTableExporter(opts) {
    var exportString = "";
    var sortedRows = [];

    // pluck out the ids to compare against the sortAgainst rows
    var selectedIds = opts.rows.map(function (row) {
      return row.id;
    });

    // Sort the selected rows by the sortAgainst data by looping through all the
    // sortAgainst rows one by one and when it finds a sortAgainst row that was
    // selected we push that into our "sortedRows". Once the sorted rows is the
    // same length as the selected rows we can break out of the loop
    for (var i = 0; i < opts.sortAgainst.length; i++) {
      if (sortedRows.length == opts.rows.length) break;

      if (selectedIds.indexOf(opts.sortAgainst[i].id) > -1) {
        sortedRows.push(opts.sortAgainst[i]);
      }
    }

    // Take the column array and make it a string with tabs as delimiters
    exportString += opts.columns.join("\t");

    // For each row we add a new line then take the array of data and convert it
    // to a string with a tab spacer
    sortedRows.forEach(function (row) {
      exportString += "\n" + row.data.join("\t");
    });

    return exportString;
  };
})();
